'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = styleSvg;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function styleSvg(style, sourceProps) {

	if (style === undefined) style = {};
	if (sourceProps === undefined) return style;

	if (sourceProps.fill) {
		style.fill = _lodash2['default'].isString(sourceProps.fill) ? sourceProps.fill : sourceProps.fill.color;
		style.fillOpacity = !!sourceProps.fill.alpha ? sourceProps.fill.alpha / 100 : 1;
	}
	if (sourceProps.stroke) {
		style.stroke = _lodash2['default'].isString(sourceProps.stroke) ? sourceProps.stroke : sourceProps.stroke.color;
		style.strokeOpacity = !!sourceProps.stroke.alpha ? sourceProps.stroke.alpha / 100 : 1;
	}
	if (sourceProps.strokeWidth) style.strokeWidth = sourceProps.strokeWidth;
	return style;
}

module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-pathjs-chart/lib/styleSvg.js
 ** module id = 304
 ** module chunks = 0
 **/